import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=2c4fef37&scoped=true&"
import script from "./testimonial.vue?vue&type=script&lang=js&"
export * from "./testimonial.vue?vue&type=script&lang=js&"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=2c4fef37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4fef37",
  null
  
)

export default component.exports